export default __webpack_public_path__ + "static/media/Coin.d1eb4454.svg";